import React from 'react'
// containers
import SecurityContainer from 'containers/Security/index'

const SecurityPage: React.FC = () => <SecurityContainer />

export default SecurityPage
